import React, { useCallback, useState } from 'react'
import { useConfirmationModalContext } from '../../context/ConfirmationModalContext'
import { Button, IconButton, Tooltip } from '@mui/material'

const ConfirmationButton = ({
  type = 'button',
  tooltip,
  children,
  disabled = false,
  message = 'Êtes-vous sûr ?',
  onClickOk = () => {},
  onClickNo = () => {}
}) => {
  const { confirm } = useConfirmationModalContext()
  const [isProcessing, setIsProcessing] = useState(false)

  const handleOnClickOk = useCallback(async () => {
    if (isProcessing) return
    setIsProcessing(true)

    try {
      const result = await confirm(message)
      if (result) await onClickOk()
      else await onClickNo()
    } finally {
      setIsProcessing(false)
    }
  }, [confirm, message, onClickOk, onClickNo, isProcessing])

  if (type === 'button') {
    return (
      <Button disabled={disabled || isProcessing} onClick={handleOnClickOk}>
        {children}
      </Button>
    )
  }

  const iconBtn = (
    <IconButton disabled={disabled || isProcessing} onClick={handleOnClickOk}>
      {children}
    </IconButton>
  )

  return tooltip ? <Tooltip title={tooltip}>{iconBtn}</Tooltip> : iconBtn
}

export default ConfirmationButton
